module.exports = __webpack_public_path__ + "img/ic_baby_co2.b3afbb28.png";